module.exports = __webpack_public_path__ + "media/images/tailwind/icon-stroke-down-f949f2da099e9479ac9899b2e93535b5.png";